export const UPLOAD_STATUS = {
  INITIAL: 'initial',
  UPLOADING: 'uploading',
  UPLOAD_FAILED: 'uploadFailed',
  UPLOAD_COMPLETE: 'uploadComplete',
} as const

export type UploadStatus = (typeof UPLOAD_STATUS)[keyof typeof UPLOAD_STATUS]
